<template>
    <section>
        <div class="row justify-content-end mx-0 mb-3">
            <el-tooltip placement="bottom" content="Descargar plantilla de inventario" effect="light">
                <div class="btn-action border ml-2">
                    <vue-excel-xlsx
                    class="btn"
                    :data="examplePlantilla"
                    :columns="fieldsPlantilla"
                    :filename="'plantilla_traslados'"
                    :sheetname="'sheetname'"
                    >
                        <i class="icon-descargar f-18 text-general" />
                    </vue-excel-xlsx>
                </div>
            </el-tooltip>
            <div class="btn-general border ml-2 cr-pointer" @click="subirArchivo()">
                <span class="mx-2">Trasladar Stock</span>
            </div>
        </div>
        <el-tabs type="border-card">
            <el-tab-pane label="Entradas">
                <div class="row mx-0">
                    <div class="col-12">
                        <el-table
                        id="cont-scroll"
                        stripe
                        :data="entradas"
                        class="cr-pointer"
                        style="width: 100%"
                        >
                            <el-table-column label="Barcode" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.barcode }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Producto" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.producto }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Cantidad" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ agregarSeparadoresNumero(scope.row.cantidad, 0) }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Origen" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.origen }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Responsable" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.responsable }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Fecha" sortable min-width="140" class-name="f-14 text-general">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.fecha | helper-fecha('DD/MM/YYYY') }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="Salidas">
                <div class="row mx-0">
                    <div class="col-12">
                        <el-table
                        id="cont-scroll"
                        stripe
                        :data="salidas"
                        class="cr-pointer"
                        style="width: 100%"
                        >
                            <el-table-column label="Barcode" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.barcode }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Producto" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.producto }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Cantidad" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ agregarSeparadoresNumero(scope.row.cantidad, 0) }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Destino" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.destino }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Responsable" class-name="text-center f-14 text-general" min-width="100">
                                <template slot-scope="scope">
                                    <p class="cr-pointer">
                                        {{ scope.row.responsable }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Fecha" sortable min-width="140" class-name="f-14 text-general">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.fecha | helper-fecha('DD/MM/YYYY') }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <modal-subir-stock ref="modalImportarStock" @update="listarTraslados" />
    </section>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import VueExcelXlsx from "vue-excel-xlsx";
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)
Vue.use(VueExcelXlsx)
export default {
    components: {
        modalSubirStock: () => import('~/pages/cedis/partials/modalImportarTraslados')
    },
    data(){
        return {
            cargando: false,
            examplePlantilla:[{barcode:'',cantidad:'',valor:''}],
            entradas:[],
            salidas:[]
        }
    },
    computed: {
        // ...mapGetters({
        //     cedis:'cedis/cedis'
        // }),
        id_cedis(){
            return this.$route.params.id_cedis
        },
        fieldsPlantilla(){
            return[
                {
                    label: "barcode",
                    field: "barcode",
                },
                {
                    label: "sku",
                    field: "sku",
                },
                {
                    label: "cantidad",
                    field: "cantidad",
                }
            ]
        },
    },
    created(){
        this.listarTraslados()
    },
    methods: {
        async listarTraslados(){
            try {
                const { data } = await axios.get(`cedis/${this.id_cedis}/get-traslados`)
                this.entradas = data.entradas
                this.salidas = data.salidas
            } catch (error){
                this.error_catch(error)
            }
        },
        subirArchivo(){
            this.$refs.modalImportarStock.toggle();
        },
    }
}
</script>
